import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/containers/business-detail/index.tsx")